import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AuthService } from '../../services/auth-service'
import * as api from '../../api'
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import { Grid, Modal, Button, Message } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import FilterableDatatable from "../../components/table/filterable-data-table";

import { FilePond } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { apiUrl } from "../../config.js"
import DocumentTableHeader from './document-table-header';
import UserPolicyTableRow from './userpolicy-table-row.jsx';


function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}

const authService = new AuthService();

class UserPolicy extends Component {

    constructor(props) {
        super(props);

        this.authServices = new AuthService();

        this.state = {
            dataProvider: new ApiDataProvider(api.getDocuments, [this.props.location.state.isUserPolicyMode ? -150 : this.props.customerId]),
            documentsCount: {},
            files: [],
            updatedKey : 0,
            isAdmin: false, // Default to false until the check is complete
            showErrorHide : true,
            errorDetails : ""


        }

    
    }

    componentDidMount = () => {
       
        ReactGA.pageview('documents');

               // Check if the user is an admin
               this.checkAdminStatus();
    };

    checkAdminStatus = async () => {
        const isAdmin = await this.authServices.isUserAdmin();
        this.setState({ isAdmin });
    };

    componentDidUpdate(prevProps) {
        // Check if the isUserPolicyMode prop has changed
 

        if (this.props.location.state.isUserPolicyMode !== prevProps.location.state.isUserPolicyMode) {
            // If it has, update the dataProvider state
            this.setState({
                dataProvider: new ApiDataProvider(api.getDocuments, [this.props.location.state.isUserPolicyMode ? -150 : this.props.customerId])
            });
        }
    }
    
    

    onFilesUpdated = (fileItems) => {
        this.setState({
            files: fileItems.map(fileItem => fileItem.file)  
        });
        
    };

    

    onModalClosed = () => {
        this.setState(prevState => ({ updatedKey: prevState.updatedKey + 1 }));
    };

    render() {
       
        return (
            <div className="main-container">
<Helmet>
    <title>Inenco Portal | {this.props.location.state.isUserPolicyMode ? "User Policy" : "Documents"}</title>
</Helmet>
<Grid padded stackable columns='equal'>
    <Grid.Row>
        <Grid.Column>
            <h2>{this.props.location.state.isUserPolicyMode ? "User Policy" : "Documents"}</h2>
        </Grid.Column>
        <Grid.Column width={2} floated='right'>
            {( (this.state.isAdmin && this.props.location.state.isUserPolicyMode) ) &&
            <Modal size="large" trigger={<Button color='orange' floated='right'>Upload {this.props.location.state.isUserPolicyMode ? "User Policy" : "Documents"}</Button>} centered={false} onClose={this.onModalClosed} closeIcon>
                <Modal.Header><h2>Upload {this.props.location.state.isUserPolicyMode ? "User Policy" : "Documents"}</h2></Modal.Header>
                <Modal.Content>
                <Message color='grey' fluid>
          
            <Message.Content>
                When uploading a new User Policy the system will expire all previous policys and prompt users upon next login to review and accept the latest terms.
           </Message.Content>
           
          </Message>
                                    <Grid padded stackable columns='equal' verticalAlign='middle'>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <FilePond onupdatefiles={this.onFilesUpdated} allowMultiple={false} allowRevert={false} allowRemove={false} allowProcess={false}
                                                  acceptedFileTypes={[
                                                    
                                                    'application/pdf' // .pdf
                                                 
                                                ]}
                                                 server={{
                                                    process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {

                                                        const formData = new FormData();
                                                        formData.append(fieldName, file, file.name);
                                                        formData.append("client", this.props.location.state.isUserPolicyMode ? -150 : authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                                        formData.append("uploadedBy", this.props.location.state.isUserPolicyMode ? 'Inenco' : authService.getUserData(AuthService.EMAIL_KEY));
                                                        
                                                        const request = new XMLHttpRequest();

                                                        request.open('POST', `${apiUrl}/Documents/PublishUserPolicyDocument`);
                                                        request.setRequestHeader(
                                                            'Authorization', `bearer ${localStorage.getItem("token")}`);

                                                        request.upload.onprogress = (e) => {
                                                            progress(e.lengthComputable, e.loaded, e.total);
                                                        };

                                                        request.onload = (e) => {
                                                            if (request.status >= 200 && request.status < 300) {
                                                               
                                                                load(request.responseText);

                                                            }
                                                            else {
                                                                var obj = JSON.parse(e.srcElement.response);

                                                             
                                                                this.setState({
                                                                    showErrorHide: false,
                                                                    errorDetails: obj.error
                                                                  
                                                                })
                                                                        error('failed upload : ' + obj.error
                                                                        );
                                                            }
                                                        };

                                                        request.send(formData);

                                                        return {
                                                          
                                                            abort: () => {
                                                                request.abort();
                                                                abort();
                                                            }
                                                        };
                                                    }
                                                }} />
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                        <div className="ui error message" hidden={this.state.showErrorHide}  > 
                    <div className="header">
                    {this.state.errorDetails}
</div>
      
                </div></Grid.Row>
                                    </Grid>
                                </Modal.Content>
                            </Modal>
    }
                        </Grid.Column>
                    </Grid.Row>
                   
                </Grid>


                <Grid.Row>
                    <Grid.Column>
                        <div className="table-container">
                            <FilterableDatatable dataProvider={this.state.dataProvider} name="Documents" canExport={false} allowFileMetadata={true}
                                        contextData={{ customerId: this.props.location.state.isUserPolicyMode ? -150 : this.props.customerId }}  
                                 key={this.state.updatedKey} 
                                headerComponent={DocumentTableHeader} rowComponent={UserPolicyTableRow} />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </div>
        );
    }
}

const wrap = connect(mapDispatchToProps, mapStateToProps);
export default wrap(UserPolicy);